import { render } from "./DefaultImagesView.vue?vue&type=template&id=40c6dcc8&ts=true"
import script from "./DefaultImagesView.vue?vue&type=script&lang=ts"
export * from "./DefaultImagesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__